import { render, staticRenderFns } from "./toggleWeightCost.vue?vue&type=template&id=aaa537bc"
import script from "./toggleWeightCost.js?vue&type=script&lang=js&external"
export * from "./toggleWeightCost.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports